import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'job'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      description: this.string(''),
      profile_id: this.number(0),
      feed_id: this.number(0),
      network_id: this.number(0),
      items_for_processing: this.number(0),
      done: this.number(0),
      errors: this.string(''),
      items_fetched: this.number(0),
      items_new: this.number(0),
      items_approved: this.number(0),
      items_rejected: this.number(0),
      items_tagged: this.number(0),
      scheduled_at: this.string(''),
      performed_at: this.string(''),
      created_at: this.string(''),
      updated_at: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: process.env.VUE_APP_APIS_FETCHER_ADMIN,
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/jobs',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/jobs/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/jobs',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/jobs/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/jobs/:id',
          method: 'delete',
        },
      },
    },
  }
}
